import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpStatusCode } from '../utility/HttpStatusCode';
import { Router } from '@angular/router';


/**
 * This is used to logout the user, when the server responds with an unathorized status code.
 * Especially when the session token expires.
 * @export
 * @class ErrorInterceptor
 * @implements {HttpInterceptor}
 */
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private _router: Router) { }


    /**
     * Intercepter intercepts the responses, and then process based on the recieved status code
     * Read more : http://jasonwatmore.com/post/2018/05/23/angular-6-jwt-authentication-example-tutorial
     * @param {HttpRequest<any>} request
     * @param {HttpHandler} next
     * @returns {Observable<HttpEvent<any>>}
     * @memberof ErrorInterceptor
     */
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request).pipe(catchError(err => {
            let errorMessage = '';
            if (err instanceof ErrorEvent) {
              // client-side error
              errorMessage = `Client-side error: ${err.error.message}`;
            } else {
              // backend error
              errorMessage = `Server-side error: ${err.status} ${err.message}`;
            }
            
            if ([HttpStatusCode.HTTP_GONE,HttpStatusCode.HTTP_NO_CONTENT,HttpStatusCode.HTTP_NOT_FOUND,HttpStatusCode.HTTP_BAD_REQUEST].includes(err.status)) {
                this._router.navigate([`/${err.status}`]);
            }
            
            return throwError(errorMessage);

        }))
    }
}
